/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/no-duplicate-string */

/*
 * Disabled the following rules:
 * @typescript-eslint/naming-convention
 * @typescript-eslint/no-empty-interface
 * @typescript-eslint/no-unused-vars
 * sonarjs/no-duplicate-string
 * as MUI theme override required override interfaces.
 * Also, it has no sense to move out css variables into another variable
 *
 * More details on style overrides here https://mui.com/material-ui/customization/theme-components/#default-props
 */
import {createTheme} from "@mui/material/styles";

declare module "@mui/material/Button" {
	// allows to rewrite theme options

	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface ButtonPropsVariantOverrides {
		pure: true;
		customFilter: true;
	}

	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface ButtonPropsColorOverrides {
		adornment: true;
		link: true;
		pure: true;
	}

	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface ButtonClasses {
		textAdornment: string;
		textLink: string;
		textPure: string;
		pure: string;
		customFilter: string;
	}
}

export const buttonsTheme = createTheme({
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 4,
					lineHeight: "20px",
					padding: "0 5px",
					fontWeight: 500,
					fontSize: "13px",
					fontFamily: "var(--fontFamilySecond)",
				},
				text: {
					color: "#3A3A3C",
					"&:hover": {
						background: "var(--primaryColor)",
						color: "#fff",
					},
				},
				textSecondary: {
					background: "var(--primaryColor)",
					color: "#fff",
					"&:hover": {
						background: "#60161c",
					},
				},
				textSizeSmall: {
					fontSize: "11px",
					lineHeight: "150%",
				},
				pure: {
					background: "transparent",
					width: "auto",
					height: "auto",
					border: "none",
					maxWidth: "auto",
					minWidth: "auto",
				},
				customFilter: {
					background: "#eeeeee",
					color: "#19181A",
					borderRadius: 0,
					"&:hover": {
						background: "var(--primaryColor)",
						color: "#fff",
						opacity: 1,
					},
					"&.open": {
						background: "var(--primaryColor)",
						color: "#fff",
						borderRadius: 0,
						"&:hover": {
							background: "var(--primaryColor)",
							color: "#fff",
							opacity: 1,
						},
					},
				},
			},
		},
	},
});
